import React from "react";
import { formatDateWithoutSeconds } from "../util/dateformatter";

const NotificationList = ({ notifications, onClick }) => {
    const hasUnread = notifications.some((notif) => !notif.read)
    return (
        <div>
            {!hasUnread && <p className="text-lg mt-4 font-semibold ">You're all caught up!</p>}
            {notifications.map((notif, index) => {
                const isFirstUnread = index == 0 && !notif.read
                const isFirstRead = index >= 0 && notif.read && !notifications[index - 1]?.read;

                return (
                    <React.Fragment key={notif._id}>
                        {isFirstUnread && <p className="text-lg mt-4 font-semibold ">Unread</p>}
                        {isFirstRead && <p className="text-gray-400 text-lg mt-4 font-semibold ">Older notifications</p>}

                        <div className="flex items-center p-4 cursor-pointer hover:bg-gray-200 hover:bg-opacity-50 rounded-lg"
                            onClick={() => onClick(notif)}>
                            <div className="flex-1">
                                <p className={`${notif.read ? 'text-gray-400  font-semibold text-md' : 'font-bold text-lg'}`}>
                                    {notif.text}
                                </p>
                                <p className={`text-sm ${notif.read ? 'text-gray-400' : 'text-gray-800'}`}>{formatDateWithoutSeconds(notif.created)}</p>
                            </div>
                        </div>

                    </React.Fragment>
                );
            })}
        </div>

    );
};

export default NotificationList;
